var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EBFCF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4246 14.1821H6V16.5957H11.4246V14.1821Z",
    fill: "#05AB80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68914 12.7298V12.7297L8.6861 11.114L9.69369 12.7297H11.3092L9.54872 10.1949L11.1856 7.56107H9.5912L8.69318 9.15917L7.75993 7.56107H6.21138L7.82349 10.0853L6.10889 12.7298H7.68914Z",
    fill: "#05AB80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5911H12.5754V13.0046H18V10.5911Z",
    fill: "#05AB80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7H12.5754V9.41358H18V7Z",
    fill: "#05AB80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.1821H12.5754V16.5957H18V14.1821Z",
    fill: "#05AB80"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.df6ae451.svg";
export { ForwardRef as ReactComponent };